import { render, staticRenderFns } from "./messageDialog.vue?vue&type=template&id=500b63a4&"
import script from "./messageDialog.vue?vue&type=script&lang=js&"
export * from "./messageDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports